import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { accountDeletionApi as n } from "@maat/api-main";
import { authQueryKeys as r } from "@maat/store-auth";
//#region src/account-deletion/useRestoreAccountMutation.ts
var i = () => {
	let i = t();
	return e({
		mutationFn: n.restoreAccount,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: r.me() }), i.invalidateQueries({ queryKey: r.state() }), i.removeQueries({ queryKey: ["permission"] });
		}
	});
};
//#endregion
export { i as useRestoreAccountMutation };
